import { Context } from "csi/def/Context";
import StringRenderer from "csi/heading/String";
import declare from "dojo/_base/declare";

const WbsName = declare(StringRenderer, {
	/** Render link to WBS if true. To be enabled via xml */
	linkEnabled: false,

	/**
	 * Enable link rendering
	 */
	canLink(): boolean {
		return !!this.linkEnabled;
	},

	/**
	 * Add WBS cnl as secondary (SURL) parameter to anchor hash
	 * Add Tab and Type parameters as well
	 */
	onAnchorHashParams(ctx: Context, params: Record<string, string>) {
		params.SURL = ctx.getNode()?.$URL;
		params.Tab = "Wbs";
		params.Type = ctx.getNodeParent().$Type;
	},
});

export = WbsName;